<template>
  <div id="url-preview">
    <a id="preview-url" :href="url" target="_blank">
      <div id="title-with-link">
        <div id="preview-title">
          {{ title }}
        </div>

        <img id="link" src="../assets/link.png" alt="" />
      </div>

      <div id="preview-description">
        {{ description }}
      </div>
      <div>
        <img class="preview-image" :src="image" alt="" />
      </div>
      <div id="url-link">
        {{ prettyURL }}
      </div>
    </a>
  </div>
</template>

<script>
export default {
  name: "UrlPreviewCard",
  props: {
    title: String,
    description: String,
    image: String,
    url: String,
  },
  computed: {
    prettyURL: function () {
      return this.url.split("://")[1].split("/")[0];
    },
  },
};
</script>

<style>
#url-preview {
  background-color: rgba(30, 30, 30, 1);
  border-radius: 8px;
  padding: 20px 27px 20px 27px;
}

#title-with-link {
  display: grid;
  grid-template-areas: "title link";
}

#preview-title {
  grid-area: title;
  font-weight: 700;
  color: white;
  padding-right: 20px;
}

#link {
  grid-area: link;
  width: 20px;
  justify-self: flex-end;
  align-self: center;
}

#preview-description {
  padding-top: 15px;
  font-weight: 400;
  color: rgb(204, 204, 204);
  padding-bottom: 15px;
}

#preview-url {
  color: rgb(38, 150, 255);
}

.preview-image {
  width: 100%;
}

#url-link {
  font-size: 14px;
  padding-top: 4px;
  word-break: break-all;
}

a {
  text-decoration: none;
}
</style>